/**
 * Wrapper for react-router-dom Link for consistent styling.
 */

import {urlPrefixed} from '@wandb/common/config';
import {Colors} from '@wandb/common/css/globals.styles';
import {FCWithRef} from '@wandb/common/util/types';
import React from 'react';
import {Link as LinkComp} from 'react-router-dom';
import styled from 'styled-components';

export const Link = styled(LinkComp)`
  font-weight: 600;
  color: ${Colors.TEAL_DARK};
  &:hover {
    color: ${Colors.TEAL_LIGHT};
  }
`;

const A = styled.a`
  font-weight: 600;
  color: ${Colors.TEAL_DARK};
  &:hover {
    color: ${Colors.TEAL_LIGHT};
  }
`;

// Code duplication with frontends/app/weave-ui/common/src/util/links.tsx
export const TargetBlank: FCWithRef<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> = React.memo(
  React.forwardRef(({children, ...passthroughProps}, ref) => {
    // Enforce an absolute prefixed url for blank targets
    if (
      passthroughProps.href != null &&
      !passthroughProps.href.startsWith('http')
    ) {
      passthroughProps.href = urlPrefixed(passthroughProps.href);
    }
    return (
      <A
        target="_blank"
        rel="noopener noreferrer"
        {...passthroughProps}
        ref={ref}>
        {children}
      </A>
    );
  })
);
